// Every character in this game's script, in a sheet over the game: the phone keeps its seat, and
// the sheet goes away when the screen changes (a vote turn, a night prompt).
import { useScript } from "../hooks/useScript";
import type { PlayerView } from "../protocol";
import { CharacterList, CountSummary, JumpChips, kindJumps } from "./Characters";
import { Sheet } from "./Sheet";

export function CharactersSheet({
  open,
  onClose,
  view,
}: {
  open: boolean;
  onClose: () => void;
  view: PlayerView;
}) {
  return (
    <Sheet open={open} onClose={onClose} label="Characters">
      <div className="row-between">
        <h3>Characters</h3>
        <button className="icon-btn" onClick={onClose}>
          Close
        </button>
      </div>
      <CharactersBody view={view} />
    </Sheet>
  );
}

/** Mounted only while the sheet is open, so the counts load when someone looks. */
function CharactersBody({ view }: { view: PlayerView }) {
  // the list is in every view; only the counts need the catalog, and they are optional
  const script = useScript(view.config.script_id);
  return (
    <div className="guide stack">
      <p className="small muted">Only some of these are in this game.</p>
      {typeof script === "object" && (
        <CountSummary counts={script.counts} players={view.seats.length} />
      )}
      <JumpChips items={kindJumps(view.roles)} />
      <CharacterList roles={view.roles} />
    </div>
  );
}
